export const CardV2LayoutClasses =
  '[.tactic-v2_&]:md:shadow-componentCard [.tactic-v2_&]:md:rounded-v2-layout-card [.tactic-v2_&]:md:border [.tactic-v2_&]:md:border-neutral-100 [.tactic-v2_&]:bg-v2-card';
export const MobileTopMargin = '[.tactic-v2_&]:mt-12';
export const MobileBottomCalcPercent = 'h-[calc(100%-103px)]';
export const MobileBottomCalcVh = 'h-[calc(100vh-103px)]';
export const MobileMapTopMargin = 'mt-[140px]';
export const MobileMapBottomMargin = 'mb-[53px]';